import { type TagModel } from '@/shared/api'
import { TABLE_PAGE_SIZE_OPTIONS } from '@/shared/lib/query'
import { TableWrapper } from '@/shared/ui'
import { Table, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import {
  $tagsTablePage,
  $tagsTablePageSize,
  tagsTablePageChanged,
  tagsTablePageReset,
  tagsTablePageSizeChanged,
  tagsTableQuery,
} from '../../model/tags-table.model'
import { useTagsTableColumns } from './useTagsTableColumns'

interface TagsTableProps {
  onEdit: (tagId: number) => void
}
export function TagsTable({ onEdit }: TagsTableProps) {
  const { data, pending } = useUnit(tagsTableQuery)

  const page = useUnit($tagsTablePage)
  const pageSize = useUnit($tagsTablePageSize)

  const changePage = useUnit(tagsTablePageChanged)
  const changePageSize = useUnit(tagsTablePageSizeChanged)
  const resetPage = useUnit(tagsTablePageReset)
  const tableColumns: TableProps<TagModel>['columns'] = useTagsTableColumns({
    onEdit,
  })

  if (!data?.items || !data.items.length) {
    return null
  }

  const onTableChange: TableProps<TagModel>['onChange'] = (
    pagination,
    _filters,
    _sorter,
  ) => {
    if (pagination.current && pagination.pageSize) {
      if (pagination.current !== page) {
        changePage(pagination.current)
      }
      if (pagination.pageSize !== pageSize) {
        changePageSize(pagination.pageSize)
        resetPage()
      }
    }
  }

  return (
    <TableWrapper>
      <Table
        sticky
        showSorterTooltip={false}
        rowKey={(record) => record.id}
        bordered
        columns={tableColumns}
        dataSource={data.items}
        loading={pending}
        onChange={onTableChange}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: data.totalItems,
          showSizeChanger: true,
          pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
          locale: { items_per_page: 'Жанров на странице' },
        }}
      />
    </TableWrapper>
  )
}
